export const SEARCH_REFERRALS = 'referral_list.SEARCH_REFERRALS';
export const SEARCH_REFERRALS_SUCCESS = 'referral_list.SEARCH_REFERRALS_SUCCESS';
export const SEARCH_REFERRALS_FAILURE = 'referral_list.SEARCH_REFERRALS_FAILURE';

export const REFRESH_REFERRAL_STATUS = 'referral_list.REFRESH_REFERRAL_STATUS';
export const REFRESH_REFERRAL_STATUS_SUCCESS = 'referral_list.REFRESH_REFERRAL_STATUS_SUCCESS';
export const REFRESH_REFERRAL_STATUS_FAILURE = 'referral_list.REFRESH_REFERRAL_STATUS_FAILURE';

export const LIST_REFERRALS = 'referral_list.LIST_REFERRALS';
export const LIST_REFERRALS_SUCCESS = 'referral_list.LIST_REFERRALS_SUCCESS';
export const LIST_REFERRALS_FAILURE = 'referral_list.LIST_REFERRALS_FAILURE';

export const FETCH_REFERRAL_DETAILS = 'referral_list.FETCH_REFERRAL_DETAILS';
export const FETCH_REFERRAL_DETAILS_SUCCESS = 'referral_list.FETCH_REFERRAL_DETAILS_SUCCESS';
export const FETCH_REFERRAL_DETAILS_FAILURE = 'referral_list.FETCH_REFERRAL_DETAILS_FAILURE';

export const CLOSE_DIALOGS = 'referral_list.CLOSE_DIALOGS';

export const FETCH_REFERRAL_CONTENT = 'referral_list.FETCH_REFERRAL_CONTENT';
export const FETCH_REFERRAL_CONTENT_SUCCESS = 'referral_list.FETCH_REFERRAL_CONTENT_SUCCESS';
export const FETCH_REFERRAL_CONTENT_FAILURE = 'referral_list.FETCH_REFERRAL_CONTENT_FAILURE';

export const OPEN_REFERRAL_DETAILS_DIALOG = 'referral_list.OPEN_REFERRAL_DETAILS_DIALOG';